import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Select } from 'antd';

import { getTrailerRequestStatusEffect } from '@/redux/Savers/SaversEffects';

const TrailerStatusSelector = ({ placeholder, id, onChange, className, mode, value }) => {
  const [options, setOptions] = useState([]);
  const { selectedCompany } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);

  const getUserList = async () => {
    try {
      setLoading(true);
      const { data } = await getTrailerRequestStatusEffect();
      const options = data.map((row) => ({
        label: row.codeDesc,
        value: row.codeId,
      }));
      setOptions(options);
    } catch (error) {
      console.error(error, 'error');
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: Todo: add missing dependencies
  useEffect(() => {
    getUserList();
  }, [selectedCompany]);

  return (
    <Select
      mode={mode}
      value={value || []}
      className={className}
      placeholder={placeholder}
      onChange={onChange}
      options={options}
      loading={loading}
    />
  );
};

export default TrailerStatusSelector;
